export default "__VITE_ASSET__NBKKVfjs__"